module.exports = __webpack_public_path__ + "images/ac00fffe1e01f438945aca067e9c1c61-IMG_6002.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/bedroom/IMG_6002.jpg
// module id = ./src/assets/images/slides/bedroom/IMG_6002.jpg
// module chunks = 0